import ApiKeysTab from "../components/admin/ApiKeysTab";

export default function ApiAccess() {
    return (
        <div className="space-y-6" data-testid="api-access-page">
            <div>
                <h1 className="font-display text-3xl font-bold tracking-tight">API Erişimi</h1>
                <p className="mt-1 text-sm text-muted-foreground">
                    Harici uygulamalarınızın (ERP, muhasebe, e-ticaret siteniz vb.) hesabınıza bağlanması için kimlik bilgileri oluşturun.
                    İmzalı uçlar: tedarikçiler kendi tekliflerini (<span className="font-mono">/api/v1/offers</span>), mağazalar kendi siparişlerini (<span className="font-mono">/api/v1/orders</span>) okuyabilir; katalog uçları (<span className="font-mono">/api/v1/products</span>, <span className="font-mono">/api/v1/categories</span>) herkese açıktır.
                </p>
            </div>
            <ApiKeysTab admin={false} />
        </div>
    );
}
